/**
 * BLOCK - BUNDLE SUMMARY
 */

if (!customElements.get('bundle-summary')) {
  customElements.define('bundle-summary',
    class BundleSummary extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          details: this.querySelector('.bundle-summary-details'),
          summary: this.querySelector('.bundle-summary-summary'),
          message: this.querySelector('[data-bundle-summary-message]'),
          products: this.querySelector('[data-bundle-summary-products]'),
          firstItem: this.querySelector('bundle-summary-item[hidden]'),
          totalPrice: this.querySelector('[data-bundle-total-price]'),
          totalPriceCompare: this.querySelector('[data-bundle-total-price-compare]'),
          cta: this.querySelector('.bundle__button-checkout')
        };

        this.init();
        this.setupEventListeners();   
      }

      // Inits the custom element
      init() {
        if (this.elements.details !== null) {
          window.innerWidth < 990 ? this.elements.details.removeAttribute("open") : this.elements.details.setAttribute("open", "");
        }
      }
    
      // Creates the event listeners
      setupEventListeners() {
        window.addEventListener('resize', this.onWindowResize.bind(this));
        document.addEventListener('pack-product:added', this.onPackProductAdded.bind(this));
        document.addEventListener('pack-product:updated', this.onPackProductUpdated.bind(this));
        if (this.elements.cta !== null) this.elements.cta.addEventListener('click', this.onPackProductSubmitted.bind(this));
        document.addEventListener('cart-drawer:updated', this.onCartDrawerUpdated.bind(this));
      }

      // On window resize
      onWindowResize(event) {
        this.init();
        this.adjustHeight();
      }
    
      // On adding a product in the pack
      onPackProductAdded(event) {
        if (this.elements.products !== null) {
          var variantId = event.detail.variantId,
              variant = event.detail.dataProductJson.variants.filter((element) => element.id == variantId).shift(),
              bundleSummaryItem = this.querySelector('bundle-summary-item[data-variant-id="' + variantId + '"]:not([hidden])');
          
          if (bundleSummaryItem === null) {
            if (this.elements.firstItem !== null) {
              bundleSummaryItem = this.elements.firstItem.cloneNode(true);     
              bundleSummaryItem.removeAttribute('hidden');
              bundleSummaryItem.dataset.variantId = variantId;
              bundleSummaryItem.querySelector('.bundle-summary-item__title').textContent = event.detail.dataProductJson.title;
              bundleSummaryItem.querySelector('.bundle-summary-item__selected-options span').textContent = variant.title;
              bundleSummaryItem.querySelector('.bundle-summary__price span').dataset.price = variant.price;
              bundleSummaryItem.querySelector('.bundle-summary__price del').dataset.comparePrice = variant.compare_at_price === null ? variant.price : variant.compare_at_price;
              bundleSummaryItem.querySelector('.bundle-summary__price span').textContent = themeVendor.themeCurrency.formatMoney(variant.price, theme.moneyFormat);
              bundleSummaryItem.querySelector('.bundle-summary__price del').textContent = themeVendor.themeCurrency.formatMoney(variant.compare_at_price, theme.moneyFormat);
              bundleSummaryItem.querySelector('[data-quantity-field]').value = 1;

              let bundleSummaryItemImage = bundleSummaryItem.querySelector('.bundle-summary-item__image-container img'),
                oldImageSrc = bundleSummaryItemImage.getAttribute('src'),
                oldImageSrcUrl = oldImageSrc.split('&width=').shift(),
                oldImageSrcSet = bundleSummaryItemImage.getAttribute('srcset'),
                newImageSrc = oldImageSrc.replace(oldImageSrcUrl, variant.featured_image.src),
                newImageSrcSet = oldImageSrcSet.replaceAll(oldImageSrcUrl, variant.featured_image.src),
                newImageAlt = variant.featured_image.alt;

              bundleSummaryItemImage.setAttribute('src', newImageSrc);
              bundleSummaryItemImage.setAttribute('srcset', newImageSrcSet);
              bundleSummaryItemImage.setAttribute('alt', newImageAlt);
    
              this.elements.products.insertAdjacentElement('beforeend', bundleSummaryItem);    
            }
          } else {
            bundleSummaryItem.querySelector('[data-quantity-field]').value = parseInt(bundleSummaryItem.querySelector('[data-quantity-field]').value) + 1;
          }

          this.dispatchCustomEvent('pack-product:updated', true, '');
        }
      }
    
      // On updating a product in the pack
      onPackProductUpdated(event) {
        this.setTotalPackProducts();
        this.updatePackPrices();
        this.updateCta();
        this.toggleSummary();
        this.adjustHeight();
        this.updateProgressBar();
      }

      // Add the pack products to cart
      onPackProductSubmitted() {
        var variantId = '',
            variantQuantity = 1;

        let formData = {
         'items': []
        };

        if (this.elements.cta !== null) this.elements.cta.disabled = true;
        
        this.elements.products.querySelectorAll('bundle-summary-item').forEach((element) => {
          variantId = element.dataset.variantId;
          variantQuantity = parseInt(element.querySelector('[data-quantity-field]').value);

          if (variantQuantity > 0) {
            let itemData = {
              'id': variantId,
              'quantity': variantQuantity,
              'properties': {
                _isBundle: 'true',
              }
            }
  
            formData.items.push(itemData);
          }
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          this.dispatchCustomEvent('cart:updated', true, null);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      // On cart drawer updated
      onCartDrawerUpdated() {
        this.reset();
      }

      // Dispatch an event
      dispatchCustomEvent(eventName, bubbles, details) {
        const customEvent = new CustomEvent(eventName, {
          bubbles: bubbles,
          detail: details
        });
        
        document.dispatchEvent(customEvent);
      }

      // Debounce
      debounce(fn, time) {
        let timeout;
        return function () {
          // eslint-disable-next-line prefer-rest-params
          if (fn) {
            const functionCall = () => fn.apply(this, arguments);
            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
          }
        };
      }

      // Gets the total number of products in the pack
      getTotalPackProducts() {
        return parseInt(this.elements.products.dataset.productsCount);
      }

      // Sets the total number of products in the pack
      setTotalPackProducts() {
        var totalPackProducts = 0;
        
        this.elements.products.querySelectorAll('[data-quantity-field]').forEach((element) => {
          totalPackProducts += parseInt(element.value);
        });
        
        this.elements.products.dataset.productsCount = totalPackProducts;
      }

      // Updates the pack prices
      updatePackPrices() {
        var bundleTotalPrice = 0,
            bundleTotalPriceCompare = 0;
        
        this.elements.products.querySelectorAll('bundle-summary-item').forEach((element) => {
          var elementQuantity = parseInt(element.querySelector('[data-quantity-field]').value),
              elementTotalPrice = element.querySelector('.bundle-summary__price span'),
              elementTotalPriceCompare = element.querySelector('.bundle-summary__price del'),
              elementTotalPriceValue = elementTotalPrice.dataset.price * elementQuantity,
              elementTotalPriceCompareValue = elementTotalPriceCompare.dataset.comparePrice * elementQuantity;

          bundleTotalPrice += elementTotalPriceValue;
          bundleTotalPriceCompare += elementTotalPriceCompareValue;
          
          elementTotalPrice.textContent = themeVendor.themeCurrency.formatMoney(elementTotalPriceValue, theme.moneyFormat);
          elementTotalPriceCompare.textContent = themeVendor.themeCurrency.formatMoney(elementTotalPriceCompareValue, theme.moneyFormat);  

          elementTotalPriceValue < elementTotalPriceCompareValue ? elementTotalPriceCompare.hidden = false : elementTotalPriceCompare.hidden = true;
        });
        
        this.elements.totalPrice.textContent = themeVendor.themeCurrency.formatMoney(bundleTotalPrice, theme.moneyFormat);
        this.elements.totalPriceCompare.textContent = themeVendor.themeCurrency.formatMoney(bundleTotalPriceCompare, theme.moneyFormat);

        bundleTotalPrice < bundleTotalPriceCompare ? this.elements.totalPriceCompare.hidden = false : this.elements.totalPriceCompare.hidden = true;
      }

      // Updates the cta
      updateCta() {
        this.getTotalPackProducts() > 0 ? this.elements.cta.disabled = false : this.elements.cta.disabled = true;
      }

      // Opens or closes the summary
      toggleSummary() {
        if (this.getTotalPackProducts() > 0) {
          this.elements.details.open = true;
          if (window.innerWidth < 990) {
            setTimeout(() => {
              this.elements.details.open = false;
            }, 1000);
          }
        } else if (window.innerWidth < 990) {
          this.elements.details.open = false;
        }
      }

      // Adjust the max height of the products part
      adjustHeight() {
        const bundleSummaryMaxHeight = parseInt(window.getComputedStyle(this).maxHeight);
        var bundleSummaryHeight = this.offsetHeight,
            bundleProductsHeight = this.elements.products.offsetHeight,
            bundleSummaryWithoutProductsHeight = bundleSummaryHeight - bundleProductsHeight,
            bundleProductsMaxHeight = bundleSummaryMaxHeight - bundleSummaryWithoutProductsHeight;

        if (this.elements.products !== null) this.elements.products.style.maxHeight = bundleProductsMaxHeight + 'px';
      }

      // Updates the progress bar
      updateProgressBar() {
        this.bundleProgressBar = document.querySelector('bundle-progress-bar[data-type="pack"]');
        this.bundleProgressBar.init();
      }

      // Resets the selection
      reset() {
        this.elements.products.querySelectorAll('bundle-summary-item').forEach((element) => {
          if (!element.hidden) {
            element.onButtonRemoveClick(null);
          }
        });
      }
    }
  );
}

/**
 * BLOCK - BUNDLE SUMMARY ITEM
 */

if (!customElements.get('bundle-summary-item')) {
  customElements.define('bundle-summary-item',
    class BundleSummaryItem extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          bundleSummary: this.closest('bundle-summary'),
          buttonMinus: this.querySelector('[data-quantity-minus]'),
          quantityField: this.querySelector('[data-quantity-field]'),
          buttonPlus: this.querySelector('[data-quantity-plus]'),
          buttonRemove: this.querySelector('[data-item-remove]')
        };

        this.setupEventListeners();
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.buttonMinus !== null) this.elements.buttonMinus.addEventListener('click', this.onButtonMinusClick.bind(this)); 
        if (this.elements.buttonPlus !== null) this.elements.buttonPlus.addEventListener('click', this.onButtonPlusClick.bind(this)); 
        if (this.elements.buttonRemove !== null) this.elements.buttonRemove.addEventListener('click', this.onButtonRemoveClick.bind(this));
      }

      // On clicking on the minus button
      onButtonMinusClick(event) {
        if (this.elements.quantityField !== null) {
          if (parseInt(this.elements.quantityField.value) > 1) {
            this.elements.quantityField.value = parseInt(this.elements.quantityField.value) - 1;
            this.closest('bundle-summary').dispatchCustomEvent('pack-product:updated', true, '');
          } else {
            this.onButtonRemoveClick(event);
          }
        }
      }

      // On clicking on the plus button
      onButtonPlusClick(event) {
        if (this.elements.quantityField !== null) {
          this.elements.quantityField.value = parseInt(this.elements.quantityField.value) + 1;
          this.closest('bundle-summary').dispatchCustomEvent('pack-product:updated', true, '');
        }        
      }

      // On clicking on the remove button
      onButtonRemoveClick(event) {
        this.elements.quantityField.value = 0;
        this.closest('bundle-summary').dispatchCustomEvent('pack-product:updated', true, '');
        this.remove();
      }
    }
  );
}